import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Checkbox: ComponentStyleConfig = {
  baseStyle: {
    label: {
      fontFamily: 'Open sans, sans-serif'
    }
  },
  sizes: {},
  variants: {},
  defaultProps: {
    colorScheme: 'twitter',
    iconColor: 'blue.400'
  }
};

export default Checkbox;
